import { useQuery } from '@apollo/client/react';
import type { GroupedOptionsType } from '../../common-ui/form-fields/Dropdown';
import type { DropdownOption } from '../utils/optionTransformers';
import { getGroupedVehicleTypeOptionsByNoOfDrivers } from '../utils/vehicleTypesUtils';
import { allVehicleTypesForCustomerAndRouteQuery } from './allVehicleTypesForCustomerAndRouteQuery';
import type { VehicleType } from './fragments/gql/VehicleType';
import type { QueryResult } from './types/QueryResult';

export const useVehicleTypesForCustomerAndRouteAsOptions = (
  customerNo: number | null,
  routeCode: string | null,
  skip: boolean = false,
): QueryResult<GroupedOptionsType<DropdownOption<VehicleType>>> => {
  const { data, loading, error } = useQuery(allVehicleTypesForCustomerAndRouteQuery, {
    variables: {
      customerNo: customerNo!,
      routeCode: routeCode!,
    },
    skip: !customerNo || !routeCode || skip,
  });
  const vehicleTypes = getGroupedVehicleTypeOptionsByNoOfDrivers(
    data?.viewer?.vehicleType?.allForCustomerNoAndRouteCode?.vehicleTypes ?? [],
  );
  return [vehicleTypes, loading, error];
};
